<template>

  <div v-show="visible" class="tab-content">
    <slot v-if="show"/>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        show: false,
        visible: false
      }
    },
    name: 'Tab',
    props: {
      id: { required: false },
      name: { required: true, type: String },
      quantity: { default: null, type: Number },
      startActive: { default: false, type: Boolean },
    },
    watch: {
      visible(value) {
        if (!this.show && value)
          this.show = true
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "./src/assets/utilities/variables";

  .tab-content {
    padding: 1.618rem;
    background: var(--tab-active-bg);
    color: var(--primary-text-color);
    border: 1px solid var(--border-color);
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-top-right-radius: 5px;
  }
</style>
